const Auth = {
  // A
  automate_your_hr_operations_and_focus_on_your_business:
    'Automate your HR operations and focus on <br /> your business',
  attendance: 'Attendance',
  // B
  // C
  code_valid_until: 'Your current <b>code</b> is valid for only <b>{{time}}</b> minutes.',
  confirm_password: 'Confirm Password',
  current_password: 'Current Password',
  password_complexity_note:
    'It should have at least <b>one number</b>, <b>one uppercase letter</b>, and <b>one symbol</b>. <br /><br /> Password can’t contain <b>user’s first name</b>, <b>last name</b>, or <b>email address</b>.',
  minimum_password_length_note: 'Password must be 8 characters at least.',
  // D
  didn_recieve_an_email: 'Didn’t recieve an email?',
  // E
  enter_six_digit_code: 'Enter six digit code',
  email: 'Email',
  // F
  forgot_password: 'Forgot password?',
  // G
  // H
  hr_management: 'HR management',
  // I
  // J
  jisr_login_authentication: '{{name}} login authentication',
  // K
  keep_me_logged_in_for_30_days: 'Keep me logged in for 30 days',
  // L
  login: 'Login',
  login_six_digit_code_note:
    'We’ve sent you a 6 digit code on your email. Please, check it and enter a six-digit code below',
  login_with_office365: 'Login with Office 365',
  // M
  // N
  new_password: 'New Password',
  // O
  // P
  password: 'Password',
  // Q
  // R
  reports_and_more: 'Reports and more',
  resend_new_password_creation_link: 'Resend new password creation link',
  resend_new_code: 'Resend new code',
  // S
  submit: 'Submit',
  slug: 'Organization name',
  sso_login: 'SSO Login',
  // T
  two_factor_verification: 'Two factor verification',
  time_session_out: 'Session Time out',
  time_session_out_description:
    'The account will be logout after 4 hours in case of no action in the page.',
  try_again: 'Try again',
  // U
  // V
  visit_our_knowledgebase: 'Visit our knowledgebase',
  // W
  // X
  // Y
  exceeded_tallowed_attempts:
    'Your account is locked due to multiple wrong attempts. you can unlock it by changing your password.',
  // Z

  application: {
    login: 'Login for {{name}}',
  },
  date: {
    long: 'MMMM Do, YYYY',
  },
  two_lines: 'Line 1<br />Line 2',
}

export default Auth
